// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader_container__HyXfn","label":"ModalHeader_label__1Biev"};